import { Alert, Button, Center, Loader, Stack } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

import { useSession } from '../api/queries';
import { LoginScreen } from './LoginScreen';

/**
 * Decides what the browser gets to see: the ledger, or the login form.
 *
 * The service answers whether it asks for a login at all, so a deployment
 * without accounts — a local run, say — goes straight through.
 */
export function AuthGate({ children }: { children: ReactNode }) {
  const { data: session, isPending, error, refetch } = useSession();

  if (isPending) {
    return (
      <Center mih="100dvh">
        <Loader />
      </Center>
    );
  }

  if (error !== null) {
    return (
      <Center mih="100dvh" px="md">
        <Stack gap="md" align="center">
          <Alert color="red" variant="light" icon={<IconAlertTriangle size={18} stroke={1.5} />}>
            {error.message}
          </Alert>
          <Button
            variant="default"
            onClick={() => {
              void refetch();
            }}
          >
            Повторить
          </Button>
        </Stack>
      </Center>
    );
  }

  if (session.required && session.login === null) {
    return <LoginScreen />;
  }

  return <>{children}</>;
}
